import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
}

const gameInfoDialog = (state = initialState, action) => {
  switch (action.type) {
    case types.gameInfoDialog.OPEN:
      return { ...state, open: true }
    case types.gameInfoDialog.CLOSE:
      return { ...state, open: false }
    default:
      return state
  }
}

export default gameInfoDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/GameInfoDialog.js